import { render, staticRenderFns } from "./ListApprover.vue?vue&type=template&id=63f01939&lang=pug&"
import script from "./ListApprover.vue?vue&type=script&lang=js&"
export * from "./ListApprover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports